module.exports = __webpack_public_path__ + "static/img/bg26.e1a0b233.png";